import PartnerPromoCodesRoute from '@playground/features/promo-codes/PartnerPromoCodesRoute'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_app/_partners/promo-codes/$partnerId')({
  component: PartnerPromoCodesRoute,
})
